/*
 * Splits a svg `path`'s `d` into an array of x/y coordinates
 */
export default (path, sampleInterval = 5) => {
  let node = document.createElementNS('http://www.w3.org/2000/svg','path')

  node.setAttribute('d', path)

  let result = []
    , totalLength = node.getTotalLength()
    , maxSample = 1000000

  sampleInterval = Math.min(sampleInterval, totalLength || 1)

  // Make sure we're not looping more times than `maxSample`
  if (totalLength / sampleInterval > maxSample) {
    // We'd end up looping to sample points and crash the browser
    // Restrict the sampleInterval. See Impact #49250
    sampleInterval = totalLength / maxSample
  }

  for (let i = 0; i <= totalLength + sampleInterval; i += sampleInterval) {
    let pt = node.getPointAtLength(i)
    result.push([pt.x, pt.y])
  }

  return result
}
